<div class="project-page">
  <header class="project-header">
    <p class="eyebrow">Portfolio :: Notepad</p>
    <h1>Notepad</h1>
    <div class="meta-badges">
      <span>Productivity</span>
      <span>Mobile</span>
      <span>Java</span>
      <span>Android</span>
    </div>
  </header>

  <div class="content-grid">
    <section class="project-copy">
      <p>
        Notepad is a lightweight, eye-friendly note-taking app designed for adding, editing, and deleting
        notes without unnecessary complexity.
      </p>

      <ul class="feature-list">
        <li>Fast note creation and editing.</li>
        <li>Intuitive, lightweight interface.</li>
        <li>Day and night themes.</li>
        <li>Focused on accessible everyday use.</li>
      </ul>

      <a class="project-link" target="_blank"
         href="https://play.google.com/store/apps/details?id=pl.jawegiel.simplenotepad&hl=en">Download on Google Play</a>
    </section>

    <aside class="project-visual screenshot-gallery">
      <img class="phone-shot" src="../../../../assets/images/screen_1_en.png" alt="Notepad screenshot 1">
      <img class="phone-shot" src="../../../../assets/images/screen_2_en.png" alt="Notepad screenshot 2">
      <img class="phone-shot" src="../../../../assets/images/Screenshot_2.png" alt="Notepad screenshot 3">
      <img class="phone-shot" src="../../../../assets/images/screen_4_en.png" alt="Notepad screenshot 4">
      <img class="phone-shot" src="../../../../assets/images/screen_3_en.png" alt="Notepad screenshot 5">
      <img class="phone-shot" src="../../../../assets/images/screen_5_EN_old.png" alt="Notepad screenshot 6">
      <img class="phone-shot" src="../../../../assets/images/screen_6_en.png" alt="Notepad screenshot 7">
      <img class="phone-shot" src="../../../../assets/images/screen_5_en.png" alt="Notepad screenshot 8">
    </aside>
  </div>
</div>
